import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ResponseInterceptors implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(res => {
        if (res instanceof HttpResponse) {
          return res;
          
        }
      }),
    );
  }
}

// import {
//   HttpInterceptor,
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpResponse,
//   HttpErrorResponse
// } from '@angular/common/http';

// import { Injectable } from '@angular/core';

// import {
//   Observable,
//   throwError
// } from 'rxjs';

// import {
//   tap,
//   catchError
// } from 'rxjs/operators';

// @Injectable({
//   providedIn: 'root'
// })
// export class ResponseInterceptors
//   implements HttpInterceptor {

//   constructor() {}

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {

//     return next.handle(req).pipe(

//       tap((event: HttpEvent<any>) => {

//         if (event instanceof HttpResponse) {

//           console.log(
//             'API Response =>',
//             event
//           );

//           // optional response handling
//           // example:
//           // if (event.body?.status === 200) {}
//         }
//       }),

//       catchError((error: HttpErrorResponse) => {

//         console.error(
//           'API Error =>',
//           error
//         );

//         return throwError(() => error);
//       })
//     );
//   }
// }



